import React from 'react'
import { User } from '../interfaces/Types'

import { UserModuleProfile } from '../interfaces/ModuleTypes'
import { getGuid } from '../utils/Utils'

export interface SessionType {
  sessionGUID: string
  user: User
  userProfile: UserModuleProfile
  LMSAvailable: boolean
  initComplete: boolean
  errorMessage: string
}

export const initialSession: SessionType = {
  sessionGUID: getGuid(),
  user: {} as User,
  userProfile: {} as UserModuleProfile,
  LMSAvailable: false,
  initComplete: false,
  errorMessage: ''
}

const context = React.createContext<SessionType>(initialSession)

const Session = context
export const SessionProvider = context.Provider
export const SessionConsumer = context.Consumer

export default Session